import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	Button,
	IconButton,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import heartIcon from '../../../assets/Images/FilledRedIcon.svg';
import recentQuestionsIcon from '../../../assets/Images/RecentQuestions.svg';
import NewChatIcon from '../../../assets/Images/NewChatIcon.svg';
import NewChatIconWhite from '../../../assets/Images/NewChatIconWhite.svg';
import DeleteIcon from '../../../assets/Images/Delete.svg';
import { useEffect, useRef, useState } from 'react';
import { getQuestionHistory } from '../AIChatBotApiHit/AiChatBotApiHit';
import headerService from '../../../services/header.service';
import './AIChatBotQuestions.scss';
import { useTheme } from '@mui/material/styles';
import ToolTipOnText from '../../../components/Tooltip/Tooltip';
import AlertDialog from '../../../components/Dialog/Dialog';
import useToast from '../../../components/Toast/hooks/useToast';
import ChatBotEndpoint from '../../ChatBot/ChatBotEndpoint';
import useApiService from '../../../services/api.service';
import useLoader from '../../../hooks/useLoader';
import chatEndpoints from './Chat.endpoints';
import useLocalStorage from '../../../utils/localStorage';
import { useChatContext } from '../Chatcontext/ChatContext';
import { transformApiToChatFormat } from '../../ChatBot/ChatBotSections/PromptSection/ChatBotResponse';
import {
	hideLoader,
	showLoader,
} from '../../../components/CustomLoader/CustomLoader';
import { useLocation, useNavigate } from 'react-router-dom';

const AIChatBotQuestions = () => {
	const theme = useTheme();
	const location = useLocation();

	// ------------------ Hooks --------------------------------
	const [questions, setQuestions]: any = useState({
		recentQuestions: [],
		favouriteQuestions: [],
		faqQuestions: [],
	});
	const navigate = useNavigate();

	const [accordionExpand, setAccordionExpand]: any = useState({
		recentQuestionExpand: true,
		favQuestionExpand: true,
		faqQuestionExpand: false,
	});

	const [disableAccordionQuestion, setDisableAccordionQuestion]: any =
		useState(false);
	const toaster = useToast();

	const deleteBookmarkRef: any = useRef();
	const [deleteType, setDeleteType] = useState<'chat' | 'favourite' | null>(
		null
	);

	let [selectedQuestion, setSelectedQuestion] = useState<any>(null);
	const APIService = useApiService();
	const loader: any = useLoader();
	const {
		setIsDisabled,
		setcurrentChatHistory,
		setIsQuestionAnswer,
		chats,
		setChats,
		setIsNewChat,
		isDisabled
	} = useChatContext();

	// ----------------- Functions -----------------------------

	function modifyArray(arr: any, element: any) {
		if (arr.length === 10) {
			arr.pop(); // Remove the last element if array length is 10
		}
		arr.unshift(element); // Add the new element at the beginning of the array
		return arr;
	}

	const getChats = async () => {
		try {
			const request = {
				reqBody: {
					limit: 20,
				},
			};
			const res: any = await APIService.post(
				chatEndpoints.getChats(request),
				true
			);
			setChats(res.threads);
		} catch (err) {
			toaster.addToast({
				message: 'Something went wrong',
				timeout: 3000,
				type: 'error',
			});
			console.error(err);
		} finally {
		}
	};

	const getChatsById = async (thread_id) => {
		showLoader();
		setIsQuestionAnswer(true);
		try {
			const request = {
				reqBody: {
					thread_id,
					limit: 20,
				},
			};
			const res: any = await APIService.post(
				chatEndpoints.getChatsById(request),
				true
			);
			// setcurrentChatHistory(res.history);
			const formattedChatData = transformApiToChatFormat(res.history);
			setcurrentChatHistory(formattedChatData);
			hideLoader();
		} catch (err) {
			hideLoader();
			toaster.addToast({
				message: 'Something went wrong',
				timeout: 3000,
				type: 'error',
			});
			console.error(err);
		} finally {
		}
	};

	const onDeletingFavQuestion = async (selectedQuestion) => {
		if (!selectedQuestion) return;
		const request = {
			qid: selectedQuestion?.qid,
		};
		try {
			loader.showLoader();
			await APIService.post(ChatBotEndpoint.deleteQuestion(request), true);
			setQuestions((prev: any) => {
				const updated = { ...prev };

				['recentQuestions', 'favouriteQuestions', 'faqQuestions'].forEach(
					(section) => {
						updated[section] = updated[section].filter(
							(item: any) => item.qid !== selectedQuestion.qid
						);
					}
				);

				return updated;
			});
			setSelectedQuestion(null);
			deleteBookmarkRef.current.handleClose();
			toaster.addToast({
				message: 'Chat deleted successfully',
				timeout: 2000,
				type: 'success',
			});
		} catch (err) {
			console.error(err);
			loader.hideLoader();
		} finally {
			loader.hideLoader();
		}
	};

	const handleDeleteConfirm = async () => {
		if (!selectedQuestion || !deleteType) return;

		if (deleteType === 'chat') {
			await onDeleteQuestion();
		} else if (deleteType === 'favourite') {
			await onDeletingFavQuestion(selectedQuestion);
		}

		setDeleteType(null);
	};

	const onDeleteQuestion = async () => {
		if (!selectedQuestion) return;
		const request = {
			thread_id: selectedQuestion?.thread_id,
		};
		const currentChatThreadId = useLocalStorage.getItem('active_thread_id');
		try {
			loader.showLoader();
			await APIService.post(ChatBotEndpoint.deleteChat(request), true);
			setChats((prev) =>
				prev.filter((chat) => chat.thread_id !== selectedQuestion?.thread_id)
			);
			deleteBookmarkRef.current.handleClose();
			if (selectedQuestion?.thread_id === currentChatThreadId) {
				setcurrentChatHistory([]);
			}
			toaster.addToast({
				message: 'Chat deleted successfully',
				timeout: 2000,
				type: 'success',
			});
			setIsQuestionAnswer(false);
		} catch (err) {
			console.error(err);
			loader.hideLoader();
		} finally {
			loader.hideLoader();
		}
	};

	const openDeleteQuestionDialog = (
		question: any,
		type: 'chat' | 'favourite'
	) => {
		setSelectedQuestion(question);
		setDeleteType(type);
		deleteBookmarkRef.current.handleClickOpen();
	};

	const onDiscardDeleteQuestion = () => {
		setSelectedQuestion(null);
		deleteBookmarkRef.current.handleClose();
	};

	// ----------------- Event Handler -----------------------------
	const eventFromService = (eventData: any) => {
		let tempQuestionsArray: any = { ...questions };
		let foundedIndex = tempQuestionsArray.favouriteQuestions.findIndex(
			(item: any) => item.qid == eventData.data.qid
		);
		switch (eventData.type) {
			case 'historyQuestions':
				setQuestions({
					faqQuestions: eventData?.data.df_faq,
					recentQuestions: eventData?.data.df_history,
					favouriteQuestions: eventData?.data.df_fav,
				});
				break;
			case 'disableNewQuestion':
				// setDisableAccordionQuestion(eventData.data);
				break;
			case 'favouriteQuestion':
				setQuestions((prevState: any) => ({
					...prevState,
					favouriteQuestions: modifyArray(
						tempQuestionsArray.favouriteQuestions,
						eventData.data
					),
				}));
				break;
			case 'unFavouriteQuestion':
				if (foundedIndex != -1) {
					tempQuestionsArray.favouriteQuestions.splice(foundedIndex, 1);
					setQuestions(tempQuestionsArray);
				}
				break;
			case 'addNewRecentQuestion':
				setQuestions((prevState: any) => ({
					...prevState,
					recentQuestions: modifyArray(
						tempQuestionsArray.recentQuestions,
						eventData.data
					),
				}));
				break;
			default:
				break;
		}
	};

	const handleQuestionClick = (question: any) => {
		setcurrentChatHistory([]);
		setIsNewChat(false);
		if (question.thread_id) {
			getChatsById(question.thread_id);
			navigate(`?thread_id=${question.thread_id}`, { replace: true });
			useLocalStorage.setItem('active_thread_id', question.thread_id);
		}
	};

	const handleFavQuestionClick = (question: any) => {
		setDisableAccordionQuestion(true);
		setcurrentChatHistory([]);
		setTimeout(() => {
			const questionFromAccord = {
				type: 'newQuestionAsked',
				data: question,
			};
			headerService.emit(questionFromAccord);
		});
	};

	const toggleAccordion = (accordionType: string) => {
		const tempAccordionExpand = { ...accordionExpand };
		tempAccordionExpand[accordionType] = !tempAccordionExpand[accordionType];

		// Count open accordions
		const openAccordionCount = Object.values(tempAccordionExpand).filter(
			(isOpen) => isOpen
		).length;

		// If more than two accordions are open, close the first one
		if (openAccordionCount > 2) {
			let foundOpenAccordion = false;
			for (const key in tempAccordionExpand) {
				if (
					tempAccordionExpand[key] &&
					!foundOpenAccordion &&
					key !== accordionType
				) {
					tempAccordionExpand[key] = false;
					foundOpenAccordion = true;
				}
			}
		}

		setAccordionExpand(tempAccordionExpand);
	};

	// just remove that all

	// ----------------- Useeffect -----------------------------

	useEffect(() => {
		getQuestionHistory();
		getChats();
	}, []);

	useEffect(() => {
		const handleReload = () => {
			localStorage.removeItem('active_thread_id');
		};

		window.addEventListener('beforeunload', handleReload);

		return () => {
			window.removeEventListener('beforeunload', handleReload);
		};
	}, []);

	useEffect(() => {
		let headerSubscription = headerService?.subscribe(eventFromService);
		return () => {
			headerSubscription?.unsubscribe();
		};
	});

	useEffect(() => {
		const threadId = new URLSearchParams(location.search).get('thread_id');

		if (!threadId) return;

		getChats();
	}, [location.search]);

	const onNewChatClick = () => {
		setcurrentChatHistory([]);
		setIsDisabled(false);
		setIsQuestionAnswer(false);
		setIsNewChat(true);
		useLocalStorage.removeItem('active_thread_id');
	};

	const isDarkMode = theme.palette.mode === 'dark';

	// ----------------- Render -----------------------------
	return (
		<div className='recentQuestions'>
			{/* Recent Questions */}
			<Button
				variant='contained'
				startIcon={
					<img
						// src={isDarkMode? NewChatIcon:NewChatIconWhite}
						src={NewChatIcon}
						alt='new chat'
						height={22}
						width={22}
						style={{ marginLeft: 10 }}
					/>
				}
				onClick={onNewChatClick}
				sx={{
					textTransform: 'none',
					fontWeight: 500,
					width: '100%',
					padding: '10px',
					boxShadow: 'none',
					fontSize: '16px',
					backgroundColor: isDarkMode ? '#1A1A1A' : '#fff',
					color: isDarkMode ? '#fff' : '#1a1a1a',
					justifyContent: 'start',
					'&:hover': {
						backgroundColor: isDarkMode ? '#1A1A1A' : '#fff',
						boxShadow: '0px 4px 12px rgba(0,0,0,0.1)',
					},
				}}
			>
				New Chat
			</Button>

			<Accordion
				onChange={() => toggleAccordion('recentQuestionExpand')}
				expanded={accordionExpand.recentQuestionExpand}
			>
				<AccordionSummary
					style={{
						backgroundColor: theme.palette.mode === 'dark' ? 'black' : 'white',
					}}
					expandIcon={<ExpandMoreIcon />}
				>
					<div style={{ display: 'flex', gap: '10px' }}>
						<img src={recentQuestionsIcon} alt='chats' /> Your Chats
					</div>
				</AccordionSummary>
				<AccordionDetails
					style={{
						backgroundColor: theme.palette.mode === 'dark' ? 'black' : 'white',
	                    pointerEvents: isDisabled ? 'none' : 'auto',
					}}
				>
					{chats?.map((item: any, index: any) => (
						<Box
							key={item.qid}
							display='flex'
							justifyContent='flex-end'
							alignItems='center'
							style={{ pointerEvents: isDisabled ? 'none' : 'auto' }}
						>
							<div
								style={{
									// pointerEvents: disableAccordionQuestion ? 'none' : 'auto',
									cursor: disableAccordionQuestion ? 'not-allowed' : 'pointer',
								}}
								onClick={() => handleQuestionClick(item)}
								className='historyQuestion'
							>
								<ToolTipOnText title={item?.first_question}>
									{item.first_question.length > 27
										? `${item?.first_question.slice(0, 27)}...`
										: item?.first_question}
								</ToolTipOnText>
							</div>
							<IconButton
								onClick={() => openDeleteQuestionDialog(item, 'chat')}
							>
								<img src={DeleteIcon} alt='delete' />
							</IconButton>
						</Box>
					))}
				</AccordionDetails>
			</Accordion>

			{/* Favourite Questions */}
			<Accordion
				onChange={() => toggleAccordion('favQuestionExpand')}
				expanded={accordionExpand.favQuestionExpand}
			>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					style={{
						backgroundColor: theme.palette.mode === 'dark' ? 'black' : 'white',
					}}
				>
					<div style={{ display: 'flex', gap: '10px' }}>
						<img src={heartIcon} alt='liked' /> Favourite Questions
					</div>
				</AccordionSummary>
				<AccordionDetails
					style={{
						backgroundColor: theme.palette.mode === 'dark' ? 'black' : 'white',
						pointerEvents: isDisabled ? 'none' : 'auto'
					}}
				>
					{questions.favouriteQuestions.map((item: any) => (
						<Box
							key={item.qid}
							display='flex'
							justifyContent='flex-end'
							alignItems='center'
						    // style={{ pointerEvents: isDisabled ? 'none' : 'auto' }}

						>
							<div
								style={{
									// pointerEvents: disableAccordionQuestion ? 'none' : 'auto',
									cursor: disableAccordionQuestion ? 'not-allowed' : 'pointer',
								}}
								onClick={() => handleFavQuestionClick(item)}
								className='historyQuestion'
							>
								<ToolTipOnText title={item.question}>
									{item.question.length > 29
										? `${item.question.slice(0, 29)}...`
										: item.question}
								</ToolTipOnText>
							</div>
							<IconButton
								onClick={() => openDeleteQuestionDialog(item, 'favourite')}
							>
								<img src={DeleteIcon} alt='delete' />
							</IconButton>
						</Box>
					))}
				</AccordionDetails>
			</Accordion>

			<AlertDialog
				ref={deleteBookmarkRef}
				title='Delete Chat'
				confirm='Delete'
				discard='Cancel'
				onConfirm={handleDeleteConfirm}
				hideCloseButton
				color='error'
				onDiscard={onDiscardDeleteQuestion}
				description='Are you sure you want to delete this Chat?'
			/>
		</div>
	);
};

export default AIChatBotQuestions;
